<script lang="ts">
import type { VariantProps } from "class-variance-authority";
import { cva } from "class-variance-authority";

export const pill = cva(["inline-flex flex-none rounded-sm px-1 py-0.5 text-xs leading-none"], {
  variants: {
    variant: {
      default: ["bg-gray-200 text-slate-600"],
      acb: ["bg-indigo-200 text-indigo-600"],
      plus: ["bg-blue-100 text-blue-600"],
    },
  },
  defaultVariants: {
    variant: "default",
  },
});

export type PillProps = VariantProps<typeof pill>;
</script>

<script setup lang="ts">
const props = defineProps<{
  variant?: PillProps["variant"];
}>();
</script>

<template>
  <div :class="pill({ variant: props.variant })">
    <slot />
  </div>
</template>
